<template>
  <div class="regain-edit-dialog">
    <el-dialog
      :visible.sync="dialogVisible"
      title="Regain Edit"
      :close-on-click-modal="false"
      @close="handleClose"
    >
      <p>
        Please upload the picture of this voucher
      </p>
      <el-upload
        ref="upload-file"
        class="upload"
        action=""
        accept="image/jpg,image/png,application/pdf"
        :disabled="isBtnUploadDisabled"
        :auto-upload="false"
        :multiple="false"
        :on-change="handleChange"
        :on-remove="handleRemove"
      >
        <el-button size="small" type="primary" :disabled="isBtnUploadDisabled">
          Upload
        </el-button>
        <div slot="tip" class="el-upload__tip">
          Only supports upload in JPG、JPEG、PNG、PDF format,<br />the size of a
          single pic does not exceed 5MB;
        </div>
      </el-upload>
      <span slot="footer">
        <el-button @click="dialogVisible = false">
          Cancel
        </el-button>
        <el-button
          type="primary"
          :disabled="isBtnSubmitDisabled"
          @click="handleSubmit"
        >
          Submit
        </el-button>
        <div style="text-align: right;">
          <el-button type="text" @click="handleSubmit('skip')">
            Skip
          </el-button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { Message } from "element-ui";
import RegainMixin from "../../mixins/regain";
import request from "@/services/fulfillment-request";

export default {
  name: "RegainEditDialog",
  mixins: [RegainMixin],
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => {}
    },
    // "booking"
    // "unit"
    level: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      file: null
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(bool) {
        this.$emit("update:visible", bool);
      }
    },
    isBtnSubmitDisabled() {
      return !this.file;
    },
    isBtnUploadDisabled() {
      return !!this.file;
    }
    // TODO: 判断是否为 wait for regain 状态 —— 暂不使用
    // isWaitForRegain() {
    //   if (this.level === "booking") {
    //     return _.get(this.data, "order_base_info.status") === bookingStatusConst[CONST_waiting_for_regain];
    //   } else if (this.level === "unit") {
    //     return _.get(this.data, "status") === bookingStatusConst[CONST_waiting_for_regain];
    //   }
    //   return false
    // }
  },
  methods: {
    handleClose() {
      this.clearFile();
    },
    handleRemove() {
      this.clearFile();
    },
    handleChange(file) {
      // 5MB 校验
      if (file.size > 5 * 1024 * 1024) {
        this.clearFile();
        Message.error("file size does not exceed 5MB");
        return;
      }

      this.file = file;
    },
    clearFile() {
      this.file = null;
      this.$refs["upload-file"].clearFiles();
      this.$refs["upload-file"].$refs["upload-inner"].$refs[
        "input"
      ].value = null;
    },
    async handleSubmit(mode = "normal") {
      if (this.level === "unit") {
        // post data
        let fd = new FormData();
        fd.append("order_base_id", this.data.order_base_id);
        fd.append("unit_file_id", this.data.id);

        if (mode !== "skip") {
          fd.append("file", this.file.raw);
          await this.postFulfillmentRegainUpload({ data: fd });
        }

        await this.regain(undefined, {
          row: this.data
        });
        Message.success("Operation Successful");
      } else if (this.level === "booking") {
        // post data
        let fd = new FormData();
        fd.append("order_base_id", this.data.order_base_info_id);

        if (mode !== "skip") {
          fd.append("file", this.file.raw);
          await this.postFulfillmentRegainUpload({ data: fd });
        }

        await this.regain(this.data);
        Message.success("Operation Successful");
      }
      this.dialogVisible = false;
    },
    async postFulfillmentRegainUpload({ data }) {
      return request({
        method: 'post',
        url: '/v1/merchantcountersrv/fulfillment/fulfillment_service/regain_upload',
        data,
        headers: { 'Content-Type': 'multipart/form-data' }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.regain-edit-dialog {
  ::v-deep .el-dialog {
    .el-dialog__footer {
      padding: 10px 20px;
    }
  }
}
</style>
